import { useMemo } from 'react';
import { useTenantConfiguration } from '../../../../../hooks/use-tenant-configuration';

type ConfiguredBusinessHour = {
  daysOfWeek: number[];
  startTime: string;
  endTime: string;
};

export function useServiceProviderCalendarBusinessHours():
  | ConfiguredBusinessHour[]
  | undefined {
  const { serviceProviderCalendarBusinessHours } = useTenantConfiguration();

  return useMemo(() => {
    if (!serviceProviderCalendarBusinessHours) {
      return undefined;
    }

    return serviceProviderCalendarBusinessHours.map(businessHour => ({
      daysOfWeek: businessHour.daysOfWeek ?? [],
      startTime: businessHour.startTime ?? '',
      endTime: businessHour.endTime ?? '',
    }));
  }, [serviceProviderCalendarBusinessHours]);
}
